/**
 * Tab layout of TabContainer.
 * @public
 */
enum TabLayout {
	/**
	 * Inline type, the tab "main text" and "additionalText" are displayed horizotally.
	 * @public
	 */
	Inline = "Inline",

	/**
	 * Standard type, the tab "main text" and "additionalText" are displayed vertically.
	 * @public
	 */
	Standard = "Standard",
}

export default TabLayout;
